import React from 'react';
import { useTranslation } from 'react-i18next';
const NoRoomError = ({ className }) => {
    const { t } = useTranslation();
    return (React.createElement("div", { className: className },
        React.createElement("div", null, t('info.noNumbers')),
        React.createElement("div", null, t('info.noRoom'))));
};
export default NoRoomError;
